import {Component, OnInit} from '@angular/core';
import {ConfirmationService} from "primeng/components/common/api";
import {Router} from "@angular/router";
import {GlobalAppService} from "app/core/commons/global-app.service";
import {CategoriaDictamenService} from "../../../../service/categoria-dictamen.service";
import {CategoriaDictamen} from "../../../../domain/categoria-dictamen";
import {MessageSeverity} from "app/core/commons/message-severity";

@Component({
    selector: 'app-categoria-list',
    templateUrl: './categoria-list.component.html',
    styleUrls: ['./categoria-list.component.scss'],
    providers: [CategoriaDictamenService]

})
export class CategoriaListComponent implements OnInit {

    categorias : CategoriaDictamen[] = [];
    showModal : boolean = false;
    updateCategoria : boolean = false;
    cat : CategoriaDictamen;
    title : string = "";

    constructor(private categoriaService : CategoriaDictamenService,
                private confirmationService: ConfirmationService,
                private router: Router,
                private messageService: GlobalAppService) {
    }

    ngOnInit() {
        this.cat = new CategoriaDictamen();
        this.categoriaService.getAll().subscribe(
            cat => this.categorias = cat
        );
    }

    public addCategoria() {
        this.cat = new CategoriaDictamen();
        this.cat.name = "";
        this.title = "Nueva categoría";
        this.updateCategoria = false;
        this.showModal = true;
    }

    public editCategoria(c : CategoriaDictamen){
        this.title = "Editar la categoría";
        this.cat = c;
        this.updateCategoria = true;
        this.showModal = true;
    }

    public deleteCategoria(c : CategoriaDictamen){
        this.confirmationService.confirm({
            message: '¿Está seguro que desea eliminar la categoría?',
            icon: 'fa ui-icon-delete-forever',
            accept: () => {
                this.categoriaService.delete(c)
                    .switchMap(res => this.categoriaService.getAll())
                    .subscribe(
                        c => {
                            this.categorias = c;
                            this.messageService.sendMsg(MessageSeverity.SUCCESS, "Eliminado", "Se ha eliminado la categoría.");

                        },
                        error => {
                            this.messageService.sendMsg(MessageSeverity.ERROR, "Error", "No ha sido posible eliminar la categoría.")
                        });
            }
        });

    }

    public refresh(){
        this.categoriaService.getAll().subscribe(
            cat => this.categorias = cat
        );
        this.updateCategoria = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/dictamenes/categoria/categoria-list/categoria-list.component.ts